module.exports = __webpack_public_path__ + "img/hs_code.440f6cbc.svg";